/* eslint-disable max-lines-per-function */
import ResourceAllocationProxy from "@/proxies/back-end/support/resource-allocation";
import { get, orderBy } from "lodash";
import { getAppFeatureProp } from "@/utilities/app-feature-util";
import GetUsersMeProxy from "@/proxies/back-end/users/me";

const getDefaultState = () => {
  return {
    sleekStaffs: [],
    isNewBadgeEnabled: false,
  };
};

const state = getDefaultState();

const getters = {
  isStaffExist: (state) => state.sleekStaffs.length > 0,
};

const actions = {
  // eslint-disable-next-line complexity
  async getSupportStaffs({ commit }, platformConfig) {
    commit("setIsNewBadgeEnabled", false);
    const companyId = localStorage.getItem("companyId");
    if (companyId) {
      const support = getAppFeatureProp(platformConfig.cmsGeneralFeatureList, "support");
      if (!support.enabled) {
        return;
      }
      const staffAssigneeMapping = get(support, "value.staffAssigneeMapping", []);

      const [staffs, userDetails] = await Promise.all([
        new ResourceAllocationProxy().execute({ companyId }),
        new GetUsersMeProxy().execute(),
      ]);
      const filteredStaff = staffs.filter((staff) => staff.user);

      const resources = [];
      for (const user of filteredStaff) {
        const firstname = get(user, "user.first_name");
        const lastname = get(user, "user.last_name");
        const fullname = `${firstname} ${lastname}`;
        const initialFirstname = firstname ? firstname.charAt(0) : "";
        const initialLastname = lastname ? lastname.charAt(0) : "";
        const initials = `${initialFirstname}${initialLastname}`;
        // const fileSrc = await this.getImageURL(get(user, "user.profile_pic"));
        const fileSrc = get(user, "user.profile_pic");
        const staffMapping = staffAssigneeMapping.find((staff) => staff.type === get(user, "type"));
        const displayName = get(user, "user.display_name");
        const objectData = {
          name: displayName ? displayName : fullname,
          firstName: displayName ? displayName : firstname,
          position: get(staffMapping, "position"),
          src: fileSrc,
          initials: initials,
          order: get(staffMapping, "orderNo"),
          category: get(staffMapping, "category"),
        };
        if (staffMapping) resources.push(objectData);
      }
      commit("setSleekStaffs", orderBy(resources, "order", "asc"));

      const new_badge_tour = getAppFeatureProp(support.props, "new_badge_tour");
      if (new_badge_tour.enabled) {
        const isNewBadgeEnabled = !get(userDetails, "support_page_tour_done", false) && resources.length > 0;
        // console.log({ userDetails, isNewBadgeEnabled });
        commit("setIsNewBadgeEnabled", isNewBadgeEnabled);
      } else {
        commit("setIsNewBadgeEnabled", false);
      }
    } else {
      commit("setSleekStaffs", []);
    }
  },
};

const mutations = {
  setSleekStaffs(state, payload) {
    state.sleekStaffs = payload;
  },
  setIsNewBadgeEnabled(state, payload) {
    state.isNewBadgeEnabled = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
